var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMortarboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11V17C6 17 8 19 12 19C16 19 18 17 18 17V11",
    stroke: "#76B72A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.5L19.0647 19.8435C18.8369 20.374 19.2391 21 19.8286 21H21.1714C21.7609 21 22.1631 20.374 21.9353 19.8435L20.5 16.5ZM20.5 16.5V9.5",
    stroke: "#76B72A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 3.00881C8.99494 3.42745 4.62406 5.88446 2.46271 7.18816C1.84576 7.5603 1.84576 8.4397 2.46271 8.81184C4.62406 10.1155 8.99494 12.5725 11.88 12.9912C11.961 13.0029 12.039 13.0029 12.12 12.9912C15.0051 12.5725 19.3759 10.1155 21.5373 8.81184C22.1542 8.4397 22.1542 7.5603 21.5373 7.18816C19.3759 5.88446 15.0051 3.42745 12.12 3.00881C12.039 2.99706 11.961 2.99706 11.88 3.00881Z",
    stroke: "#76B72A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMortarboard);
export default __webpack_public_path__ + "static/media/ic-mortarboard.3321895bb19a82404d57a0f9a93f2acc.svg";
export { ForwardRef as ReactComponent };